import ResetIcon from "@material-ui/icons/RotateLeft";
import React from "react";
import SyncStatusButton from "./SyncStatusButton";

const ResetSyncStatusButton = (props) => {
	return <SyncStatusButton {...props} icon={ResetIcon} />;
};

export default ResetSyncStatusButton;
